import useCdcProps from '@/composables/useCdcProps'

export default async () => {
  const { xprops } = useCdcProps()
  const useUrlSearchParams = xprops?.useUrlSearchParams

  const { getUrlSearchParams, setUrlSearchParams } = await useUrlSearchParams()

  return { getUrlSearchParams, setUrlSearchParams }
}
